import { render } from "./RatingList.vue?vue&type=template&id=4ff0ef1a&scoped=true&ts=true"
import script from "./RatingList.vue?vue&type=script&lang=ts"
export * from "./RatingList.vue?vue&type=script&lang=ts"

import "./RatingList.vue?vue&type=style&index=0&id=4ff0ef1a&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff0ef1a"]])

export default __exports__